<div class="overlay">
    <ng-lottie  containerClass="moving-box another-class"
    [options]="options"></ng-lottie>
</div>
